import { render, staticRenderFns } from "./PrivatePurchaseKey4g.vue?vue&type=template&id=089e699d&scoped=true&"
import script from "./PrivatePurchaseKey4g.vue?vue&type=script&lang=js&"
export * from "./PrivatePurchaseKey4g.vue?vue&type=script&lang=js&"
import style0 from "./PrivatePurchaseKey4g.vue?vue&type=style&index=0&id=089e699d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089e699d",
  null
  
)

export default component.exports